import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { list_formatter } from '@core/services/DocumentFormatter';

class DocumentServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  async getList(params = {}) {
    const documents_response = await this.http.get('/', { params });
    if (documents_response && documents_response.data.length > 0) {
      documents_response.data = await list_formatter(documents_response.data);
    }
    return documents_response;
  }
  getBase64(file_id, params = {}) {
    return this.http.get(`/${file_id}/base64`, params);
  }

  getStatusInfo() {
    return this.http.get('status');
  }
}

export const DocumentService = new DocumentServiceClass({
  api_version: 2,
  resource: '/safe/documents'
});
